import { useQuery } from '@tanstack/react-query'
import { fetcher } from 'repositories/BerthApi/berthApiClient'
import { userKeys } from 'repositories/queryKeys'
import { getUserInfoEndpoint } from 'repositories/UserApi/getUserInfo/endpoint'
import { GetUserInfoResponse } from 'repositories/UserApi/getUserInfo/type'

export function useUserInfo() {
  const { data, error, isLoading } = useQuery<GetUserInfoResponse>({
    queryKey: userKeys.info(),
    queryFn: () => fetcher(getUserInfoEndpoint()),
  })

  return {
    userName: data?.data?.attributes?.name ?? '',
    isLoading,
    error,
  }
}
